import CustomCheckbox from "components/Atoms/CustomCheckbox"
import React, { useCallback } from "react"
import { useTaskSelector } from "./interfaces"
const TaskSelector = ({ value }) => {
  const id = value.id
  const [isSelected, toggleSelect] = useTaskSelector(
    useCallback(store => [!!store.selected[id], store.toggleSelect], [id])
  )
  return (
    <CustomCheckbox
      checked={isSelected}
      onChange={() => toggleSelect(id, value)}
    />
  )
}

export default TaskSelector
